import React from 'react';

const Overview = ({description}) => {
  // Sample instructor data
 

  return (
    <div className='p-3'>
       
      <h4 className="mb-3">Description</h4>
      <p>
      {description}
         </p>
      
     
    </div>
  );
};

export default Overview;